import { render, staticRenderFns } from "./formModule.vue?vue&type=template&id=f5dab3e2"
import script from "./formModule.vue?vue&type=script&lang=js"
export * from "./formModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports